import * as React from "react";

export const SvgExpertise = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={45} height={44} fill="none" {...props}>
		<circle cx={22.5} cy={22} r={21.5} fill="#fff" stroke="#FFB11A" />
		<path
			fill="#FFB11A"
			d="M26.094 11.219h-8.625a3.594 3.594 0 0 0-3.594 3.594V27.03a3.594 3.594 0 0 0 3.594 3.594h7.906v-2.236a5.013 5.013 0 0 1-1.438-3.514 5.037 5.037 0 0 1 5.032-5.031c.244 0 .483.023.718.057v-5.088a3.594 3.594 0 0 0-3.593-3.594ZM21.192 27.03h-3.723a.719.719 0 1 1 0-1.437h3.723a.718.718 0 1 1 0 1.437Zm.172-3.593H17.47a.719.719 0 1 1 0-1.438h3.895a.719.719 0 1 1 0 1.438Zm2.178-3.594H17.47a.719.719 0 1 1 0-1.438h6.073a.719.719 0 1 1 0 1.438Zm2.552-3.594h-8.625a.719.719 0 1 1 0-1.438h8.625a.719.719 0 1 1 0 1.438ZM28.969 29.9c-.773 0-1.502-.179-2.157-.49v2.646c0 .574.64.916 1.118.598l1.039-.693 1.038.693a.719.719 0 0 0 1.118-.598V29.41a5.004 5.004 0 0 1-2.156.49Z"
		/>
		<path fill="#FFB11A" d="M28.969 28.469a3.594 3.594 0 1 0 0-7.188 3.594 3.594 0 0 0 0 7.188Z" />
	</svg>
);
